var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { YES_OR_NO_CHOICES } from '@declaration/helpers/choices';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import { QuestionComponent, QuestionProps } from '@declaration/question';
const claim = namespace('claim');
const counting = namespace('counting');
let HasDamagesQuestion = class HasDamagesQuestion extends QuestionComponent {
    constructor() {
        super(...arguments);
        this.yesNoQuestionValuesAndTradKeys = YES_OR_NO_CHOICES;
    }
    updateClaim(hasDamages) {
        this.updateAndSaveCounting({
            countingPayload: {
                hasDamages,
            },
            step: this.step,
        });
    }
    get answer() {
        if (this.counting.hasDamages === null) {
            return null;
        }
        return this.counting.hasDamages
            ? this.$tc('claim.qualification.has.damages.to.declared.sumup.yes')
            : this.$tc('claim.qualification.has.damages.to.declared.sumup.no');
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], HasDamagesQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    counting.State('counting')
], HasDamagesQuestion.prototype, "counting", void 0);
__decorate([
    counting.Action('updateAndSaveCounting')
], HasDamagesQuestion.prototype, "updateAndSaveCounting", void 0);
HasDamagesQuestion = __decorate([
    Component({
        components: { RadioPrimaryButton, QuestionPanel },
        props: QuestionProps,
    })
], HasDamagesQuestion);
export default HasDamagesQuestion;
